/* Sweet Bar: independent photo preview; packaging remains a separate cart item. */
if (!customElements.get('sweetbar-gift-picker')) {
  customElements.define('sweetbar-gift-picker', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        if (!this.isConnected || this.ready) return;
        this.dialog = this.querySelector('[data-picker-dialog]');
        this.trigger = this.querySelector('[data-open]');
        this.addButton = this.querySelector('[data-add]');
        this.quantity = this.querySelector('[data-quantity]');
        this.quantityMinus = this.querySelector('[data-quantity-minus]');
        this.quantityPlus = this.querySelector('[data-quantity-plus]');
        this.status = this.querySelector('[data-status]');
        this.confirmButton = this.querySelector('[data-gift-confirm]');
        this.clearButton = this.querySelector('[data-gift-clear]');
        this.removeButtons = Array.from(this.querySelectorAll('[data-remove-packaging]'));
        this.choices = Array.from(this.querySelectorAll('[data-choice]'));
        this.photoButtons = Array.from(this.querySelectorAll('[data-photo-open]'));
        this.photoDialog = this.querySelector('[data-photo-dialog]');
        this.fullImage = this.querySelector('[data-full-image]');
        this.photoStatus = this.querySelector('[data-photo-status]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.ready = true;
        this.defaultTriggerLabel = this.dataset.giftDefaultLabel || this.trigger.querySelector('span')?.textContent?.trim() || '';
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (!this.dialog.open) this.dialog.showModal();
        });
        this.clearButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.busy || this.viewingCart) return;
          this.clearGift();
        });
        this.querySelector('[data-close]').addEventListener('click', () => {
          if (!this.busy && !this.viewingCart) this.dialog.close();
        });
        this.dialog.addEventListener('cancel', (event) => {
          if (this.busy || this.viewingCart || this.photoDialog.open) event.preventDefault();
        });
        this.dialog.addEventListener('close', () => {
          if (this.photoDialog.open) this.photoDialog.close();
          if (!document.querySelector('cart-drawer.active') && this.isConnected) this.trigger.focus({ preventScroll: true });
        });
        this.dismissOutside(this.dialog, () => !this.busy && !this.viewingCart && !this.photoDialog.open);
        this.photoButtons.forEach((button) => button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.openPhoto(button);
        }));
        this.querySelector('[data-photo-close]').addEventListener('click', () => this.photoDialog.close());
        this.photoDialog.addEventListener('close', () => {
          this.photoRequest = (this.photoRequest || 0) + 1;
          if (!this.photoDialog.open && this.dialog.open && this.photoTrigger?.isConnected) {
            this.photoTrigger.focus({ preventScroll: true });
          }
        });
        // Native Escape closes only the top dialog; don't forward it to theme modals.
        this.photoDialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') event.stopPropagation();
        });
        this.photoDialog.addEventListener('keyup', (event) => {
          if (event.key === 'Escape') event.stopPropagation();
        });
        this.dismissOutside(this.photoDialog, () => true);
        this.querySelectorAll('img[data-fallback]').forEach((image) => {
          const recover = () => {
            const url = image.dataset.fallback;
            if (!url) return;
            delete image.dataset.fallback;
            image.src = url;
          };
          image.addEventListener('error', recover, { once: true });
          if (image.complete && !image.naturalWidth) recover();
        });
        this.querySelector('[data-cart-link]')?.addEventListener('click', async (event) => {
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function') return;
          event.preventDefault();
          if (this.busy || this.viewingCart) return;
          this.viewingCart = true;
          this.updateQuantityButtons();
          try {
            const ids = drawer.getSectionsToRender().map((item) => item.id);
            const sections = await this.fetchSections(ids);
            if (!this.sectionsValid(drawer, sections)) throw new Error('Cart sections unavailable');
            const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            const freshDrawer = html.querySelector('cart-drawer');
            if (freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
            this.dialog.close();
            drawer.setActiveElement(this.trigger);
            drawer.renderContents({ sections });
          } catch (error) { window.location.assign(this.dataset.cartUrl); }
          finally { this.viewingCart = false; this.updateQuantityButtons(); }
        });
        this.quantity.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); this.addPackaging(); }
        });
        this.quantity.addEventListener('input', () => this.updateQuantityButtons());
        this.quantity.addEventListener('change', () => this.updateQuantityButtons());
        this.quantityMinus.addEventListener('click', () => this.changeQuantity(-1));
        this.quantityPlus.addEventListener('click', () => this.changeQuantity(1));
        this.updateQuantityButtons();
        this.choices.forEach((choice) => choice.addEventListener('click', () => {
          if (this.busy || this.viewingCart || choice.disabled) return;
          const changed = this.selected !== choice;
          this.selected = choice;
          this.choices.forEach((item) => {
            item.setAttribute('aria-pressed', String(item === choice));
            item.closest('[data-card]').dataset.selected = String(item === choice);
          });
          this.removeButtons.forEach((button) => {
            button.hidden = button.closest('[data-card]')?.dataset.selected !== 'true';
          });
          this.quantity.min = choice.dataset.min || '1';
          this.quantity.step = choice.dataset.step || '1';
          if (changed) this.quantity.value = this.quantity.min;
          if (choice.dataset.max) this.quantity.max = choice.dataset.max; else this.quantity.removeAttribute('max');
          this.updateQuantityButtons();
          this.addButton.disabled = Boolean(this.uncertain);
          if (this.dataset.unifiedGift === 'true') {
            this.addButton.disabled = false;
            this.addButton.querySelector('span').textContent = this.dataset.packagingSelected || '';
          }
          if (!this.uncertain) this.status.textContent = '';
        }));
        this.removeButtons.forEach((button) => button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.dataset.unifiedGift !== 'true' || this.busy || this.viewingCart) return;
          this.selected = null;
          this.choices.forEach((item) => {
            item.setAttribute('aria-pressed', 'false');
            item.closest('[data-card]').dataset.selected = 'false';
          });
          this.removeButtons.forEach((item) => { item.hidden = true; });
          this.addButton.disabled = true;
          const label = this.addButton.querySelector('span');
          if (label) label.textContent = this.dataset.selectPackaging || '';
          this.status.textContent = '';
        }));
        this.addButton.addEventListener('click', () => {
          if (this.dataset.unifiedGift === 'true') {
            this.status.textContent = '';
            this.dispatchEvent(new CustomEvent('sweetbar:gift-change', { bubbles: true }));
            return;
          }
          this.addPackaging();
        });
        if (this.dataset.unifiedGift === 'true') {
          this.addButton.querySelector('span').textContent = this.dataset.selectPackaging || '';
          this.addButton.disabled = true;
          this.confirmButton?.addEventListener('click', () => {
            const postcards = this.querySelector('sweetbar-gift-postcards');
            const hasPackaging = Boolean(this.selected);
            const hasPostcard = Boolean(postcards?.selected);
            if (!hasPackaging && !hasPostcard) {
              this.status.textContent = this.dataset.giftEmptyMessage || '';
              return;
            }
            const packagingTitle = this.selected?.querySelector('strong')?.textContent?.trim() || '';
            const postcardTitle = postcards?.selected?.querySelector('.pc-title')?.textContent?.trim() || '';
            const summary = [packagingTitle, postcardTitle].filter(Boolean).join(' + ');
            const prefix = this.dataset.giftSummaryPrefix || '';
            this.trigger.querySelector('span').textContent = summary ? prefix + summary : this.defaultTriggerLabel;
            this.trigger.dataset.configured = summary ? 'true' : 'false';
            if (this.clearButton) this.clearButton.hidden = !summary;
            this.dialog.close();
          });
        }
      });
    }
    clearGift() {
      this.selected = null;
      this.choices.forEach((item) => {
        item.setAttribute('aria-pressed', 'false');
        const card = item.closest('[data-card]');
        if (card) card.dataset.selected = 'false';
      });
      this.removeButtons.forEach((item) => { item.hidden = true; });
      this.addButton.disabled = true;
      const packagingLabel = this.addButton.querySelector('span');
      if (packagingLabel) packagingLabel.textContent = this.dataset.selectPackaging || '';
      const postcards = this.querySelector('sweetbar-gift-postcards');
      postcards?.clearSelection?.();
      if (postcards?.message) {
        postcards.message.value = '';
        postcards.message.setCustomValidity('');
      }
      if (postcards?.counter) postcards.counter.textContent = '0 / 180';
      this.trigger.querySelector('span').textContent = this.defaultTriggerLabel;
      this.trigger.dataset.configured = 'false';
      if (this.clearButton) this.clearButton.hidden = true;
      this.status.textContent = '';
    }
    disconnectedCallback() {
      this.photoRequest = (this.photoRequest || 0) + 1;
      if (this.photoDialog?.open) this.photoDialog.close();
      if (this.dialog?.open) this.dialog.close();
    }
    updateQuantityButtons() {
      const value = Number(this.quantity.value);
      const min = Number(this.quantity.min || 1);
      const max = this.quantity.max === '' ? Infinity : Number(this.quantity.max);
      const step = Number(this.quantity.step || 1);
      const last = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
      const locked = Boolean(this.busy || this.viewingCart || this.quantity.disabled);
      this.quantityMinus.disabled = locked || value <= min;
      this.quantityPlus.disabled = locked || value >= last;
    }
    changeQuantity(direction) {
      if (this.busy || this.viewingCart || this.quantity.disabled) return;
      const button = direction > 0 ? this.quantityPlus : this.quantityMinus;
      if (button.disabled) return;
      const previous = this.quantity.value;
      if (direction > 0) this.quantity.stepUp(); else this.quantity.stepDown();
      this.updateQuantityButtons();
      if (this.quantity.value !== previous) this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }
    dismissOutside(dialog, allowed) {
      let beganOutside = false;
      const outside = (event) => {
        const box = dialog.getBoundingClientRect();
        return event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
      };
      dialog.addEventListener('pointerdown', (event) => { beganOutside = outside(event); });
      dialog.addEventListener('click', (event) => {
        if (beganOutside && outside(event) && allowed()) dialog.close();
        beganOutside = false;
      });
      dialog.addEventListener('pointercancel', () => { beganOutside = false; });
    }
    openPhoto(button) {
      if (this.busy || this.viewingCart || !this.dialog.open || this.photoDialog.open) return;
      const fullUrl = button.dataset.fullSrc;
      if (!fullUrl) return;
      const request = this.photoRequest = (this.photoRequest || 0) + 1;
      this.photoTrigger = button;
      const title = button.dataset.photoTitle || this.dataset.giftPhoto;
      this.querySelector('[data-photo-caption]').textContent = title;
      this.fullImage.alt = title;
      this.fullImage.hidden = true;
      this.fullImage.removeAttribute('src');
      this.photoStatus.textContent = this.dataset.photoLoading;
      this.photoDialog.showModal();
      this.querySelector('[data-photo-close]').focus({ preventScroll: true });
      const urls = [...new Set([fullUrl, button.dataset.fullFallback].filter(Boolean))];
      const load = (index) => {
        if (request !== this.photoRequest || !this.photoDialog.open || !this.isConnected) return;
        if (index >= urls.length) {
          this.photoStatus.textContent = this.dataset.photoError;
          return;
        }
        const image = new Image();
        image.onload = () => {
          if (request !== this.photoRequest || !this.photoDialog.open || !this.isConnected) return;
          this.fullImage.src = urls[index];
          this.fullImage.hidden = false;
          this.photoStatus.textContent = '';
        };
        image.onerror = () => load(index + 1);
        image.src = urls[index];
      };
      load(0);
    }
    sectionsValid(cart, sections) {
      if (!sections) return false;
      return cart.getSectionsToRender().every((part) => {
        if (typeof sections[part.id] !== 'string') return false;
        const html = new DOMParser().parseFromString(sections[part.id], 'text/html');
        return Boolean(html.querySelector(part.selector || '.shopify-section'));
      });
    }
    async fetchSections(ids) {
      const url = new URL(this.dataset.cartUrl, window.location.href);
      url.searchParams.set('sections', ids.slice(0, 5).join(','));
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Cart refresh failed');
        return await response.json();
      } finally { clearTimeout(timer); }
    }
    async addPackaging() {
      if (this.busy || this.viewingCart || this.photoDialog.open || this.uncertain || !this.selected || this.selected.dataset.available !== 'true') return;
      const quantity = Number(this.quantity.value);
      const id = Number(this.selected.dataset.variantId);
      if (!this.quantity.reportValidity() || !Number.isSafeInteger(quantity) || quantity < 1 || !Number.isSafeInteger(id) || id < 1) return;
      this.busy = true;
      this.addButton.disabled = true;
      this.quantity.disabled = true;
      this.updateQuantityButtons();
      this.choices.forEach((choice) => { choice.disabled = true; });
      this.addButton.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const payload = { id, quantity };
      let sectionIds = [];
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      let added = false;
      try {
        if (cart && typeof cart.getSectionsToRender === 'function') {
          sectionIds = cart.getSectionsToRender().map((section) => section.id).filter(Boolean).slice(0, 5);
          if (sectionIds.length) { payload.sections = sectionIds; payload.sections_url = window.location.pathname + window.location.search; }
        }
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin', signal: controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          this.uncertain = true;
          this.status.textContent = (typeof result.description === 'string' ? result.description : this.dataset.addError) + ' ' + this.dataset.checkCart;
          return;
        }
        added = true;
        if (this.dataset.unifiedGift === 'true') {
          this.uncertain = false;
          this.status.textContent = this.dataset.giftAdded;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sweetbar-gift-picker', productVariantId: String(id), cartData: result });
          }
        } else if (cart && typeof cart.renderContents === 'function' && sectionIds.length) {
          if (!this.sectionsValid(cart, result.sections)) result.sections = await this.fetchSections(sectionIds);
          if (!this.sectionsValid(cart, result.sections)) throw new Error('Cart sections unavailable');
          this.dialog.close();
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(this.trigger);
          cart.classList.remove('is-empty');
          cart.renderContents(result);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sweetbar-gift-picker', productVariantId: String(id), cartData: result });
        } else {
          this.uncertain = true;
          this.status.textContent = this.dataset.giftAdded;
        }
      } catch (error) {
        this.uncertain = true;
        this.status.textContent = added ? this.dataset.giftRefreshError : this.dataset.addError + ' ' + this.dataset.checkCart;
      } finally {
        clearTimeout(timer);
        this.busy = false;
        this.quantity.disabled = false;
        this.updateQuantityButtons();
        this.choices.forEach((choice) => { choice.disabled = choice.dataset.available !== 'true'; });
        this.addButton.disabled = !this.selected || Boolean(this.uncertain);
        this.addButton.removeAttribute('aria-busy');
      }
    }
  });
}

